<template>
  <div class="advantage-items">
    <div class="advantage-item">
      <div class="img-wrap">
        <img src="@/assets/archi.png" @click="goUrl('http://help.wwforu.com/part3_design_model_metric_chart_generation')">
      </div>
      <h4>多软件设计指标统计</h4>
      <p>智能统计YJK、PKPM等多款软件的设计与时程结果，一键生成比对报表，使设计对比及选波结果一目了然！</p>
    </div>
    <div class="advantage-item">
      <div class="img-wrap">
        <img src="@/assets/Motion.png" @click="goUrl('http://help.wwforu.com/part5_full_ecosystem_ground_motion_toolbox')" alt>
      </div>
      <h4>全生态地震动工具箱</h4>
      <p>提供人工波生成、天然波选波、智能截波、自动选波报告等全生态服务，9万组天然地震动满足您所有需求！</p>
    </div>
    <div class="advantage-item">
      <div class="img-wrap">
        <img src="@/assets/p.png" @click="goUrl('http://help.wwforu.com/part5_full_ecosystem_ground_motion_toolbox')" alt>
      </div>
      <h4>一键弹塑性分析</h4>
      <p>包揽多项国际竞赛大奖，将设计模型高效转化为弹塑性模型，一键开启弹塑性分析，你我都是分析能手！</p>
    </div>
    <div class="advantage-item">
      <div class="img-wrap">
        <img src="@/assets/book.png" @click="goUrl('http://help.wwforu.com/part8_structural_seismic_performance_evaluation/')" alt>
      </div>
      <h4>一键弹塑性报告</h4>
      <p>人性化三维交互平台，实现基于构件的结构抗震性能化评估，一键生成分析报告，超限分析原来如此简单！</p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goUrl(url) {
      //alert("待实现！")
      window.open(url) //新窗口打开
      // window.location.href = url//当前窗口打开
    },
  }
}
</script>

<style lang="less" scoped>
.advantage-items {
  display: flex;
  justify-content: space-around;
  align-items: baseline;
  .advantage-item {
    width: 100%;
    padding: 20px;
    text-align: center;
    .img-wrap {
      display: inline-block;
      text-align: center;
      margin-bottom: 25px;
      img {
        height: 80px;
        cursor: pointer;
      }
    }
    h4 {
      font-size: 20px;
      font-weight: 600;
      color: #000;
      line-height: 28px;
      margin-bottom: 15px;
    }
    p {
      font-size: 15px;
      font-weight: 400;
      color: #a4a8ab;
      line-height: 22px;
      text-align: justify;
    }
  }
}
@media screen and (max-width: 990px) {
  .advantage-items {
    flex-direction: column;
    padding: 0px;
    .advantage-item {
      .img-wrap {
        margin-bottom: 10px;
      }
      h4 {
        margin-bottom: 10px;
      }
    }
   
    
  }
  
      
}
</style>
